module.exports = __webpack_public_path__ + "assets/fonts/a77d72a5-0a7d-4697-8f47-f67e92a64a8c.96724be7.eot";